import styled from 'styled-components/native'
import { Pressable } from '../Pressable'
import { Label, Toggle, ToggleWrapper } from './styles'
import { RadioGroupProps } from './types'

const RadioContainer = styled.View`
  gap: 5px;
`
const Wrapper = styled.View<{ isChecked?: boolean }>`
  max-width: 100%;
  flex-direction: row;
  padding: 10px 25px 10px 15px;
  background-color: ${({ theme, isChecked }) => (isChecked ? theme.colors.primaryButtonBackground : theme.colors.tertiaryBackground)};
  border-radius: ${({ theme }) => theme.borderRadius.large}px;
  gap: 10px;
`
const RadioWrapper = styled(ToggleWrapper)`
  align-self: center;
`
const Radio = styled(Toggle)`
  height: 11px;
  width: 11px;
`

export function RadioGroup({ value, onChange, items, isDisabled = false }: RadioGroupProps) {
  return (
    <RadioContainer>
      {items.map((item) => {
        const isChecked = item.value === value

        return (
          <Pressable
            style={{ alignSelf: 'flex-start' }}
            aria-label="radio-input"
            key={item.value}
            isDisabled={isDisabled}
            onPress={() => onChange(item.value)}
            render={({ hovered }) => (
              <Wrapper isChecked={isChecked}>
                <RadioWrapper isChecked={isChecked} isHovered={hovered}>
                  <Radio isChecked={isChecked} />
                </RadioWrapper>
                <Label>{item.label}</Label>
              </Wrapper>
            )}
          />
        )
      })}
    </RadioContainer>
  )
}
